import { PrebookLeadPaxModel } from '@/__generated';
import { getFullName } from '@/helpers/string';
import React from 'react';
import LabelValueItem from './LabelValueItem';

type Props = {
  passenger: PrebookLeadPaxModel | null | undefined;
};

export default function ReadOnlyPassengerDetail({ passenger }: Props) {
  const phoneNumber = React.useMemo(() => {
    return [passenger?.phoneCode ? `(${passenger.phoneCode})` : '', passenger?.phoneNumber].filter(x => x).join(' ');
  }, [passenger]);
  return (
    <div className="row x-gap-10 y-gap-10 mt-20">
      <div className="col-12 d-flex align-items-center mb-10">
        <div className="fw-bold text-18 text-blue-1  rounded-2 pr-10 text-uppercase">LEAD GUEST DETAILS</div>
        <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
      </div>
      <div className="col-md-6 col-xs-12">
        <LabelValueItem label="Full Name" value={getFullName(passenger?.firstName, passenger?.lastName)} />
      </div>
      <div className="col-md-6 col-xs-12">
        <LabelValueItem label="Nationality" value={passenger?.countryName} />
      </div>
      <div className="col-md-6 col-xs-12">
        <LabelValueItem label="Email" value={passenger?.emailAddress} />
      </div>
      <div className="col-md-6 col-xs-12">
        <LabelValueItem label="Phone Number" value={[passenger?.phoneCode, passenger?.phoneNumber].filter(x => x).join('-')} />
      </div>
    </div>
  );
}
